import axios from 'axios';
import Vue from 'vue';
import App from './components/App.vue';
import store from './state';
import router from './router';
import wait from './plugins/wait';
import './components';
import './plugins';
import '@groovepages/gd-ui-kit/styles.css';
import config from '../../load-config';
import i18n from './plugins/i18n';

config.then((configValues) => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}/groovesell`;

  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }

  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}/groovesell`,
    appUrl: `${configValues.VUE_APP_GROOVESELL_URL}`,
    grooveappsurl: appFrontendURL,
    apiCoreUrl: `${configValues.VUE_APP_API_URL}/groovedigital`,
  };

  window.config = localConfig;
  window.gdEnv = configValues;

  Vue.config.productionTip = false;

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    store,
    router,
    wait,
    ...App,
  });
});
